<template>
	<v-card>
		<v-card-title>Access Denied</v-card-title>
		<v-card-text class="pa-4">
			<p v-if="logged_in">
				You so not have permission to access this room. Please contact Meisterworks if you think this is a mistake
			</p>
			<p v-else>
				Only logged in users can access video meetings
			</p>
			<p>If this is an error, please contact your project lead or email Meisterworks at talk@m.works</p>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn color="primary" v-if="logged_in" href="mailto:research@m.works">
				Email Us
			</v-btn>
			<v-btn color="primary" v-else to="/login">
				Log In
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	// import - from "@/components/"
	export default {
		name: "AccessDenied", 
		props: {
			
		},
		data: () => {
			return {

			}
		},
		// components: {

		// },
		computed: {
			...Vuex.mapState({
				logged_in: state => state.auth.logged_in
			})
		},
		// methods: {
		// }
		// created(){
			
		// }

	}
// </script>"